












































































import { Component, Vue } from 'vue-property-decorator'
import UserList from '@/components/UserList.vue'
import LessonProgress from '@/components/LessonProgress.vue'
import { RezitoreAdminAPI } from '@/provider/api'
import AwsExports from '@/assets/aws-exports'

@Component({
  components: {
    UserList,
    LessonProgress
  }
})
export default class User extends Vue {
  snackbar: boolean = false
  snackbarMessage: string = ''
  snackbarTimeout: number = 6000
  api: RezitoreAdminAPI = new RezitoreAdminAPI(AwsExports)
  loadingUpdate: boolean = false
  loadingCsvRequest: boolean = false
  userInfoUpdatedAt: Date | null = null
  searchConditionDivision: string = this.$store.getters.currentDivision.id
  searchConditionRewardStatus: string = this.$store.getters.currentSearchRewardStatus

  $refs!: {
    userList: UserList
  }

  mounted () {
    this.getUserInfoUpdatedAt()
  }

  get divisionName () {
    return `[ ${this.$store.getters.currentDivision.displayName} ]`
  }

  get divisions () {
    return this.$store.getters.divisionMaster
  }

  get isManager () {
    return this.$store.getters.adminType === 'manager'
  }

  onDivisionChange (divisionId: string) {
    console.log('onDivisionChange - divisionId', divisionId)
    this.$store.commit('setCurrentDivision', divisionId)
    this.$refs.userList.onDivisionChange(divisionId)
    this.getUserInfoUpdatedAt()
  }

  onRewardStatusChange (rewardStatus: string) {
    console.log('onRewardStatusChange - rewardStatus', rewardStatus)
    this.$store.commit('setCurrentSearchRewardStatus', rewardStatus)
    this.$refs.userList.onRewardStatusChange(rewardStatus)
  }

  async getUserInfoUpdatedAt () {
    const result = await this.$refs.userList.getUserInfoUpdatedAt()

    if (result === undefined) {
      return
    }
    if (result.length > 1) {
      const divisionId = this.$store.getters.currentDivision.id
      if (divisionId === '') {
        this.userInfoUpdatedAt = result.reduce((h: Date, e: any): Date => {
          const eDate = new Date(e.value)
          return h.getTime() > eDate.getTime() ? eDate : h
        }, new Date())
      } else {
        this.userInfoUpdatedAt = result.find((e: any) => {
          return e.key === `${divisionId}_updatedAt`
        }).value
      }
    } else if (result.length === 1) {
      this.userInfoUpdatedAt = result[0].value
    }
  }

  showError (message: string) {
    this.snackbarMessage = message
    this.snackbarTimeout = 60 * 1000
    this.snackbar = true
  }

  async updateUserInfo () {
    this.loadingUpdate = true
    console.log('Update user info...')
    try {
      const name = new Date().getTime() + ''
      const divisionId = this.$store.getters.currentDivision.id
      console.log('updateUserInfo - divisionId: ', divisionId)
      await this.api.execBatchUpdateUserInfoExecution(name, divisionId)
      var interval = setInterval(async () => {
        let result = await this.api.getStatusBatchUpdateUserInfomationExecution(name)
        console.log(result)
        if (result.status === 'RUNNING') {
          return
        }
        this.loadingUpdate = false
        clearInterval(interval)
        let userListRef: any = this.$refs.userList
        userListRef.onUpdateUserInfo()
        this.getUserInfoUpdatedAt()
        if (result.status === 'FAILED') {
          console.log('Failed update user info.')
          this.snackbarMessage = '更新に失敗しました. 時間をおいて再度実行して下さい.'
          this.snackbarTimeout = 60 * 1000
          this.snackbar = true
        } else {
          console.log('Finished update user info.')
          let userListRef: any = this.$refs.userList
          userListRef.onUpdateUserInfo()
          this.getUserInfoUpdatedAt()
          this.snackbarMessage = '更新が完了しました'
          this.snackbarTimeout = 60 * 1000
          this.snackbar = true
        }
      }, 2000)
    } catch (e) {
      this.loadingUpdate = false
      this.showError('更新に失敗しました。ネットワーク環境などを見直して再度実行して下さい。')
    }
  }

  async downloadCSV () {
    this.loadingCsvRequest = true
    try {
      const csv = await this.loadCsv()
      console.log(csv)
      const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], { 'type': 'text/csv' })
      const link = document.createElement('a')
      const searchCondition = this.$refs.userList.currentSearchCondition
      const division = searchCondition.division
      link.href = window.URL.createObjectURL(blob)
      link.download = `userdata_${division}_${this.userInfoUpdatedAt}.csv`
      link.click()
      this.loadingCsvRequest = false
      this.snackbarMessage = 'CSVをダウンロードします'
      this.snackbarTimeout = 60 * 1000
      this.snackbar = true
    } catch (e) {
      console.log(e)
      this.showError('CSVダウンロードに失敗しました。ネットワーク環境などを見直して再度実行して下さい。')
      this.loadingCsvRequest = false
    }
  }

  async loadCsv () {
    const searchCondition = this.$refs.userList.currentSearchCondition
    console.log('lodaCsv - searchCondition: ', searchCondition)
    const division = searchCondition.division
    if (searchCondition.crcId) {
      console.log('downloadCSV - division: ', division, ' crcId:', searchCondition.crcId)
      return this.api.getUserInfoCsv(division, undefined, undefined, searchCondition.crcId)
    } else if (searchCondition.startDate && searchCondition.endDate) {
      const startDate = new Date(searchCondition.startDate)
      const endDate = searchCondition.endDate !== ''
        ? new Date(searchCondition.endDate)
        : new Date()
      console.log('downloadCSV - division: ' + division + ' start: ', startDate, ' end: ', endDate)
      return this.api.getUserInfoCsv(division, startDate.toISOString(), endDate.toISOString())
    } else {
      console.log('downloadCSV - division: ', division)
      return this.api.getUserInfoCsv(division, undefined, undefined)
    }
  }
}
